// ** Redux, Thunk & Root Reducer Imports
import thunk from 'redux-thunk'
import createDebounce from 'redux-debounced'
import rootReducer from '../reducers/rootReducer'
import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer, createTransform  } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'

// ** init middleware
const middleware = [thunk, createDebounce()]

// ** Dev Tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

// ** Transforma el estado al persistir y rehidratar
const blacklistTransform = createTransform(
  // Durante el proceso de guardar (se ejecuta al persistir)
  (inboundState, key) => {
    if (key === 'ecommerce') {
      // Extraemos allproducts para no guardarlo
      // const { allProducts, productsPage, unfilteredProducts, productDetail, marcas, totalProducts, categories, ...rest } = inboundState;
      const { allProducts, productsPage, productDetail, totalProducts, categories, ...rest } = inboundState;
      return rest;  // Devolvemos el estado sin allproducts
    }
    return inboundState;
  },
  // Durante el proceso de rehidratar (se ejecuta al cargar de nuevo el estado)
  (outboundState, key) => {
    // Devolvemos el estado sin modificaciones al rehidratar
    return outboundState;
  },
  { whitelist: ['ecommerce'] } // Aplica solo al reducer 'ecommerce'
);

// ** Persist redux state
const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: hardSet,
  blacklist: ['invoice', 'order', 'salesQuote', 'deliveryNote'],
  transforms: [blacklistTransform] // Aplica la transformación
}

const persistedReducer = persistReducer(persistConfig, rootReducer)
// Es una opcion, rootReducer si quieres que se borre la store al refrescar,
// persisted, para que se mantenga
// const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(...middleware)))
const store = createStore(persistedReducer, {}, composeEnhancers(applyMiddleware(...middleware)))

const persistor = persistStore(store)

export { store, persistor }

// // ** Create store
// const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(...middleware)))
// export { store }


// // BLACKLIST
// const persistConfig = {
//   key: 'root',
//   storage: storage,
//   blacklist: ['navigation'] // navigation will not be persisted
// };
// // WHITELIST
// const persistConfig = {
//   key: 'root',
//   storage: storage,
//   whitelist: ['navigation'] // only navigation will be persisted
// };
